export const enData = {
  title: 'Cookies Statement',
  sections: [
    {
      title: 'How We Use Cookies and Similar Technologies',
      content: ''
    },
    {
      title: '1. What Are Cookies?',
      content: `
        <p>Cookies are small text files that are transferred from our websites, applications or services and stored on your device. Danghuan websites, online services, applications, interactive services, emails and advertisements may use cookies and similar technologies such as pixel tags and web beacons. We cannot access cookies that are not set by our websites or services.</p>
      `
    },
    {
      title: '2. How Long Do Cookies Remain on Your Device?',
      content: '',
      subsections: [
        {
          title: '(1) Session Cookies',
          content: `
            <p>These cookies remain only until you close your browser and are not permanently stored on your device. Session cookies are generally used to track the pages you visit during a browsing session in order to personalize your experience during that visit.</p>
          `
        },
        {
          title: '(2) Persistent Cookies',
          content: `
            <p>These cookies remain stored on your device until they are deleted manually or until they expire automatically. Persistent cookies may be used to remember your preferences when you revisit our website.</p>
          `
        }
      ]
    },
    {
      title: '3. We Use the Following Types of Cookies',
      content: '',
      subsections: [
        {
          title: '(1) Strictly Necessary Cookies',
          content: `
            <p>These cookies are necessary for the operation of our website and services. They may include cookies that enable access to secure areas of the website, maintain sessions or prevent fraudulent activity.</p>
          `
        },
        {
          title: '(2) Analytics or Performance Cookies',
          content: `
            <p>These cookies allow us to count visitors and understand how users interact with our website so that we can improve performance, functionality and user experience.</p>
          `
        },
        {
          title: '(3) Functional Cookies',
          content: `
            <p>These cookies recognize you when you return to our website and allow us to personalize content and remember your preferences, such as language selection.</p>
          `
        },
        {
          title: '(4) Behavioral Advertising Cookies',
          content: `
            <p>These cookies record your visit to our website, the pages you visit and the links you follow. We may use this information to make our website and advertisements more relevant to your interests. We may also share this information with third parties for advertising purposes where legally permitted.</p>
          `
        }
      ]
    },
    {
      title: '4. How We Use Cookies',
      content: '',
      subsections: [
        {
          title: '',
          content: `
            <p>(1) We and our partners may use cookies and similar technologies to better understand the functionality of our website, services and mobile platforms, including:</p>
            <ul>
              <li>how often our services are used;</li>
              <li>browsing behavior;</li>
              <li>performance and technical data;</li>
              <li>traffic sources;</li>
              <li>interactions with advertisements;</li>
              <li>device and browser information.</li>
            </ul>
            <p>We do not directly link analytics cookie data with personally identifiable information unless permitted by law.</p>
          `
        },
        {
          title: '',
          content: `
            <p>(2) We and our partners may use cookies and similar technologies to analyze trends, administer websites, monitor user activity, and collect aggregated demographic information about our user base.</p>
          `
        },
        {
          title: '',
          content: `
            <p>(3) If the “Do Not Track” function is enabled in your browser, we will respect your browser settings where legally required.</p>
          `
        },
        {
          title: '',
          content: `
            <p>(4) Like most websites, we automatically collect certain technical information including:</p>
            <ul>
              <li>IP address;</li>
              <li>browser type;</li>
              <li>internet service provider;</li>
              <li>referring and exit pages;</li>
              <li>viewed files and pages;</li>
              <li>operating system;</li>
              <li>date and time stamps;</li>
              <li>clickstream data.</li>
            </ul>
          `
        },
        {
          title: '',
          content: `
            <p>(5) We may cooperate with third-party advertising and analytics providers to display advertisements on our website or manage advertisements on third-party websites.</p>
            <p>These partners may use cookies or similar technologies to provide advertising based on your browsing activities and interests.</p>
            <p>You may manage or disable advertising cookies through your browser settings or cookie preferences.</p>
            <p>Please note that disabling personalized advertising does not mean that you will stop seeing advertisements entirely.</p>
          `
        }
      ]
    },
    {
      title: '5. Delete or Disable Cookies',
      content: `
        <p>You can manage cookie preferences through your browser settings or our cookie banner.</p>
        <p>Please refer to your browser provider’s instructions for managing cookies, including:</p>
        <ul>
          <li>Microsoft Internet Explorer</li>
          <li>Microsoft Edge</li>
          <li>Mozilla Firefox</li>
          <li>Google Chrome</li>
          <li>Safari for macOS</li>
          <li>Safari for iOS</li>
        </ul>
        <p>Please note that disabling cookies may affect the functionality of certain parts of our Services.</p>
      `
    },
    {
      title: '6. Additional Information About Cookies',
      content: `
        <p>For more information about cookies and how to configure your browser to accept, reject or delete cookies, please visit: <a href="https://www.allaboutcookies.org" target="_blank">www.allaboutcookies.org</a></p>
        <p>Please also review our Privacy Notice for additional information regarding the processing of your personal data.</p>
      `
    },
    {
      title: 'Cookie Details',
      content: `
        <p>The following table provides examples of cookies that may be used on our website <a href="https://www.danghuan.eu" target="_blank">https://www.danghuan.eu</a>:</p>
        <table>
          <thead>
            <tr>
              <th>Type</th>
              <th>Name</th>
              <th>Domain</th>
              <th>Purpose</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Necessary</td>
              <td>session_id</td>
              <td>danghuan.eu</td>
              <td>Maintains user session and authentication</td>
            </tr>
            <tr>
              <td>Necessary</td>
              <td>cookiesaccepted</td>
              <td>danghuan.eu</td>
              <td>Stores cookie consent preferences</td>
            </tr>
            <tr>
              <td>Necessary</td>
              <td>XSRF-TOKEN</td>
              <td>danghuan.eu</td>
              <td>Security and fraud prevention</td>
            </tr>
            <tr>
              <td>Necessary</td>
              <td>stayOnSite</td>
              <td>danghuan.eu</td>
              <td>Remembers regional or site selection</td>
            </tr>
            <tr>
              <td>Functional</td>
              <td>language_pref</td>
              <td>danghuan.eu</td>
              <td>Stores language preferences</td>
            </tr>
            <tr>
              <td>Analytics</td>
              <td>_ga</td>
              <td>Google Analytics</td>
              <td>Distinguishes users and analyses traffic</td>
            </tr>
            <tr>
              <td>Analytics</td>
              <td>_gid</td>
              <td>Google Analytics</td>
              <td>Distinguishes users</td>
            </tr>
            <tr>
              <td>Analytics</td>
              <td>_gat</td>
              <td>Google Analytics</td>
              <td>Regulates request rate</td>
            </tr>
            <tr>
              <td>Analytics</td>
              <td>_hjSession</td>
              <td>Hotjar</td>
              <td>Website analytics and heatmaps</td>
            </tr>
            <tr>
              <td>Advertising</td>
              <td>_fbp</td>
              <td>Meta/Facebook</td>
              <td>Advertising and conversion tracking</td>
            </tr>
            <tr>
              <td>Advertising</td>
              <td>fr</td>
              <td>Meta/Facebook</td>
              <td>Advertising relevance and delivery</td>
            </tr>
            <tr>
              <td>Advertising</td>
              <td>personalisation_id</td>
              <td>X (Twitter)</td>
              <td>Advertising and user identification</td>
            </tr>
            <tr>
              <td>Advertising</td>
              <td>_ttp</td>
              <td>TikTok</td>
              <td>Advertising and user tracking</td>
            </tr>
            <tr>
              <td>Advertising</td>
              <td>test_cookie</td>
              <td>DoubleClick</td>
              <td>Advertising optimization</td>
            </tr>
            <tr>
              <td>Advertising</td>
              <td>IDE</td>
              <td>DoubleClick</td>
              <td>Personalized advertising</td>
            </tr>
            <tr>
              <td>Advertising</td>
              <td>ANID</td>
              <td>Google</td>
              <td>Advertising preferences</td>
            </tr>
            <tr>
              <td>Advertising</td>
              <td>AID</td>
              <td>Google Ads</td>
              <td>Analytics and advertising</td>
            </tr>
            <tr>
              <td>Advertising</td>
              <td>g</td>
              <td>SmartNews Ads</td>
              <td>Personalized advertising</td>
            </tr>
          </tbody>
        </table>
      `
    },
    {
      title: '7. Managing Cookies',
      content: `
        <p>You may configure your browser to block or notify you about cookies. However, if you disable certain cookies, some parts of our website or services may not function properly.</p>
        <p>You can also manage your cookie preferences through our cookie banner or privacy settings where available.</p>
      `
    }
  ]
};
